import { forwardRef } from 'react';
import { Platform, Pressable, StyleSheet, PressableProps, View } from 'react-native';

import PlusIcon from '%assets/icons/add-post.svg';

export const FloatingAddButton = forwardRef<View, PressableProps>(
	({ style, ...pressableProps }, ref) => {
		return (
			<Pressable {...pressableProps} style={[styles.addPost, style]} ref={ref}>
				<PlusIcon />
			</Pressable>
		);
	},
);

const SIZE = 48;
const styles = StyleSheet.create({
	addPost: {
		position: Platform.select({
			default: 'absolute',
			web: 'fixed' as any, // working on web
		}),
		height: SIZE,
		width: SIZE,
		bottom: SIZE / 3,
		right: SIZE / 3,
	},
});
